import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SearchButtons from "./SearchButtons";
import ToolTips from "./ToolTips";

class SearchCurated extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toolTipText: [
        "Children who have been waiting for a sponsor for 12 months or more.",
        "The U.N. defines an orphan as a child who has lost one or both parents",
        "Children living in communities where there is a keen focus on child protection, safeguarding the rights of kids and protecting them from harm.",
        "Children living in countries affected by the hunger crisis in East Africa including Niger, Chad, Uganda, Ethiopia, and Kenya.",
      ],
    };
  }

  renderMobileToolTip(toolTipIndex) {
    if (this.props.device !== "desktop") {
      return this.state.toolTipText[toolTipIndex];
    }

    return "";
  }

  renderDesktopToolTip() {
    if (this.props.device === "desktop") {
      return <ToolTips toolTipText={this.state.toolTipText[this.props.activeToolTipIndex]} />;
    }

    return "";
  }

  renderButtons() {
    //show mobile buttons
    if (this.props.device !== "desktop") {
      return (
        <SearchButtons
          buttonId="curated-apply"
          buttonClassList="btn-primary btn-child-search__apply"
          onClickMethod={(e) => {
            this.props.toggleSearch(e);
          }}
          buttonText="Apply"
        />
      );
    } else {
      return false;
    }
  }

  render() {
    const {
      searchQuery,
      handleSearch,
      handleSearchReset,
      renderMessage,
      setSelectedValue,
      resetSearchParams,
    } = this.props;

    return (
      <section className="children-search">
        <section className="price-array">
          {this.props.device !== "desktop" ? <p>Select one</p> : ""}
          <label
            className={`price-array__option ${
              this.props.curatedSearchSelected === "longest-waiting" ? "is-selected" : ""
            }`}
            tabIndex="0"
          >
            <input
              className="price-array__input"
              type="radio"
              id="longest-waiting-search"
              name="curated-search"
              checked={this.props.curatedSearchSelected === 0}
              onChange={(e) => {
                this.props.resetSearchParams();
                this.props.handleSearch(366, "minimumDaysAwaitingSponsorshipCount", searchQuery);
                setSelectedValue("longest-waiting");
                this.props.setToolTip(0);
              }}
            />
            Longest waiting <span className="alert-info--mobile">{this.renderMobileToolTip(0)}</span>
          </label>
          <label
            className={`price-array__option ${this.props.curatedSearchSelected === "orphan" ? "is-selected" : ""}`}
            tabIndex="0"
          >
            <input
              className="price-array__input"
              type="radio"
              id="orphan-search"
              name="curated-search"
              checked={this.props.curatedSearchSelected === "orphan"}
              onChange={(e) => {
                this.props.resetSearchParams();
                this.props.handleSearch(2, "orphan", searchQuery);
                setSelectedValue("orphan");
                this.props.setToolTip(1);
              }}
            />
            Orphaned child <span className="alert-info--mobile">{this.renderMobileToolTip(1)}</span>
          </label>

          <label
            className={`price-array__option ${this.props.curatedSearchSelected === "high-risk" ? "is-selected" : ""}`}
            tabIndex="0"
          >
            <input
              className="price-array__input"
              type="radio"
              id="high-risk-search"
              name="curated-search"
              checked={this.props.curatedSearchSelected === "high-risk"}
              onChange={(e) => {
                this.props.resetSearchParams();
                this.props.handleSearch(
                  [
                    "ALB",
                    "ARM",
                    "BGD",
                    "BOL",
                    "BRA",
                    "BDI",
                    "KHM",
                    "COL",
                    "DOM",
                    "SLV",
                    "GTM",
                    "HND",
                    "IND",
                    "MEX",
                    "NIC",
                    "PER",
                    "ROU",
                    "UGA",
                  ],
                  "countryCodes",
                  searchQuery
                );
                setSelectedValue("high-risk");
                this.props.setToolTip(2);
              }}
            />
            Higher-risk area <span className="alert-info--mobile">{this.renderMobileToolTip(2)}</span>
          </label>

          <label
            className={`price-array__option ${this.props.curatedSearchSelected === "hunger" ? "is-selected" : ""}`}
            tabIndex="0"
          >
            <input
              className="price-array__input"
              type="radio"
              id="hunger-search"
              name="curated-search"
              checked={this.props.curatedSearchSelected === "hunger"}
              onChange={(e) => {
                this.props.resetSearchParams();
                this.props.handleSearch(["NER", "TCD", "UGA", "ETH", "KEN"], "countryCodes", searchQuery);
                setSelectedValue("hunger");
                this.props.setToolTip(3);
              }}
            />
            Hunger crisis area <span className="alert-info--mobile">{this.renderMobileToolTip(3)}</span>
          </label>
          {this.renderButtons()}
        </section>
        {this.renderDesktopToolTip()}
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      // getChildren: getChildren,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(SearchCurated);
